import React from 'react'
import { Contract } from '../../../types'

import HoverTooltip from '../../../../../../components/HoverTooltip'
import { CurrencyList } from '../../../../Plans/Positions/Edit/types'

interface ContractStageCountProps {
    contract: Contract
    theme: string
    currencyList: CurrencyList[]
}

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const ContractInfo: React.FC<ContractStageCountProps> = ({
    contract,
    theme,
    currencyList,
}) => {
    const currencyInfo = currencyList.find(
        (c) => Number(c.num_code) === Number(contract.currency_digital_code)
    )
    const charSign =
        Number(contract.currency_digital_code) !== 643
            ? (currencyInfo?.char_sign ?? '')
            : ''

    // --- валютные вычисления ---
    const isRub = Number(contract.currency_digital_code) === 643
    const currencyName = contract.currency_name ?? ''
    const rate =
        contract.exchange_rate != null ? Number(contract.exchange_rate) : null

    // если rub_unit_price нет, но есть rate — посчитаем
    const rubPrice =
        contract.price != null
            ? Number(contract.rub_price)
            : rate != null
              ? Number(contract.price) * rate
              : null

    const currecytooltip = (
        <>
            {!isRub ? (
                <div className="text-[12.8px]">
                    <div className="w-full text-left">{currencyName}</div>
                    {rate != null && (
                        <div className="opacity-80 w-full text-left">
                            Курс: {formatNumber(rate)}
                        </div>
                    )}
                    {/* {rubPrice != null && (
                        <div className="opacity-80 w-full text-left">
                            Цена (₽): {formatNumber(rubPrice)}
                        </div>
                    )} */}
                </div>
            ) : (
                <div className="text-[12.8px] opacity-90">{currencyName}</div>
            )}
        </>
    )
    return (
        <>
            <div className="relative flex flex-row min-w-[1260px] max-w-[1710px] min-h-[80px] gap-2 bg-[#ebebeb] dark:bg-[#111111] items-start">
                <div className="flex flex-col flex-1 h-fit mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Предмет договора
                    </div>
                    <HoverTooltip
                        tooltipText={
                            contract.subject_contract
                                ? contract.subject_contract
                                : '-'
                        }
                    >
                        <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                            {contract.subject_contract ? (
                                <p className="tworow">
                                    {contract.subject_contract}
                                </p>
                            ) : (
                                '-'
                            )}
                        </div>
                    </HoverTooltip>
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[150px] h-fit mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Сумма договора
                    </div>
                    <HoverTooltip
                        tooltipContent={currecytooltip}
                        align="right"
                        valign="bottom"
                    >
                        <div className="flex flex-col w-full h-full items-start justify-start text-xs">
                            <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                                {charSign + ' ' + formatNumber(contract.price)}
                            </div>
                            {!isRub
                                ? rubPrice != null && (
                                      <div className="flex w-full h-full items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                                          ₽ {formatNumber(rubPrice)}
                                      </div>
                                  )
                                : ''}
                        </div>
                    </HoverTooltip>
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[200px] h-full mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Номер договора
                    </div>
                    <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                        {contract.contract_name ? contract.contract_name : '-'}
                    </div>
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[100px] h-full mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Дата договора
                    </div>
                    <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                        {contract.contract_date
                            ?.split('-')
                            .reverse()
                            .join('-')
                            .replace(/[\-]/g, '.')}
                    </div>
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[200px] h-full mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Контрагент
                    </div>
                    <div className="flex flex-col w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                        {contract?.suppliers
                            ? contract?.suppliers.length > 1
                                ? contract?.suppliers.map((sup, index) => (
                                      <div key={index}>
                                          {index +
                                              1 +
                                              '. ' +
                                              sup.supplier_short_name}
                                      </div>
                                  ))
                                : contract?.suppliers.map((sup, index) => (
                                      <div key={index}>
                                          {sup.supplier_short_name}
                                      </div>
                                  ))
                            : ''}
                    </div>
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[100px] h-full mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Версия
                    </div>
                    <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                        <p className="threerow">{contract.version}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContractInfo
